import * as React from 'react';
import * as _ from 'lodash';
import * as Styles from './styles';
import { ModalGeneric } from '../index'
import { KEYS } from 'common/constants';
import delayUnmounting from '../delayUnmounting';
import ActionBar from 'components/ActionBar';
import { ChangedInfoUI } from 'features/Dealers/Listings/state/types';

export interface ModalPushProps {
    onSyncConfirmed: () => void;
    onCancel: () => void;
    onOKClose: () => void;
    shouldShow: boolean;
    isSyncing: boolean;
    modal: string;
    errorMessage?: string;
    package?:string;
    listingsChanges?: ChangedInfoUI;
}

export interface ModalPushStates {
    synced?: boolean;
}

class ModalPush extends React.Component<ModalPushProps, ModalPushStates> {

    constructor(props: ModalPushProps) {
        super(props);
        this.state = {
            synced: false,
        };
        this.onCancelClick = this.onCancelClick.bind(this)
        this.onOKCloseClick = this.onOKCloseClick.bind(this)
        this.onSyncConfirmed = this.onSyncConfirmed.bind(this)
    }

    onSyncConfirmed() {
        this.props.onSyncConfirmed();
        this.setState({ synced: true });
    }

    onCancelClick() {
        this.props.onCancel();
    }

    onOKCloseClick() {
        this.props.onOKClose();
    }

    keyDownHandle = (e) => {
        if (e.key === KEYS.ESCAPE) {
            this.props.onCancel()
        }
    }

    
    render() {        
        if (!this.state.synced || this.props.isSyncing){

            return (
            <ModalGeneric
                modal={this.props.package=='ELITE'?'pushelite':'push'}
                onKeyDown={this.keyDownHandle}
                shouldShow={this.props.shouldShow}
                errorMessage={this.props.errorMessage}
                listingsChanges={this.props.listingsChanges}
            >
                <ActionBar
                    mainActionLabel={"Push Changes"}
                    mainActionLoading={this.props.isSyncing}
                    secondaryActionLabel={"Cancel"}
                    onMainActionClick={this.onSyncConfirmed}
                    onSecondaryActionClick={this.onCancelClick}
                />
            </ModalGeneric>
            ); 

        } else if (this.state.synced && !this.props.isSyncing) {
            return (
                <ModalGeneric
                    modal={this.props.modal}
                    onKeyDown={this.keyDownHandle}
                    shouldShow={this.props.shouldShow}
                    errorMessage={this.props.errorMessage}
                >
                    <ActionBar
                        mainActionLabel={"CLOSE"}
                        onMainActionClick={this.onOKCloseClick}
                    />
                </ModalGeneric>
            );
        }
    }
}

export default delayUnmounting<ModalPushProps>(ModalPush);